import { Button, Code, Flex, Heading, VStack } from "@chakra-ui/react";
import { ReactElement, useMemo } from "react";

interface ErrorViewProps {
  error: Error;
  resetErrorBoundary: () => void;
}

export default function ErrorView(props: ErrorViewProps): ReactElement {
  const { error, resetErrorBoundary } = props;

  const message = useMemo(
    () => error?.message ?? JSON.stringify(error),
    [error]
  );

  return (
    <Flex w="100%" h="70vh" justify="center" align="center">
      <VStack
        spacing="6"
        bg="gray.100"
        rounded="lg"
        p="8"
        maxW="36rem"
        overflow=""
      >
        <Heading>Oops! Something went wrong</Heading>
        <Code
          display="block"
          w="100%"
          wordBreak="break-word"
          bg="gray.50"
          fontSize="md"
          borderWidth="2px"
          overflowY="auto"
        >
          {message}
        </Code>
        <Button
          colorScheme="blue"
          onClick={resetErrorBoundary}
          alignSelf="flex-end"
        >
          Try Again
        </Button>
      </VStack>
    </Flex>
  );
}
